import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba años gastando en cremas para la piel seca de mis manos. Con la receta de esta guía, preparé una pomada que me solucionó el problema en una semana. ¡Y sé exactamente qué tiene!',
  name: 'María G.',
  role: 'Madre de familia'
}, {
  quote: 'Las instrucciones son clarísimas. Nunca había hecho nada parecido y la base universal me salió perfecta a la primera. Ahora hago mis propios regalos para la familia.',
  name: 'Carlos R.',
  role: 'Principiante en cosmética natural'
}, {
  quote: 'La pomada para dolores musculares es una maravilla. Uso ingredientes que consigo en la herbolaria de mi barrio y el resultado es mejor que las cremas de farmacia.',
  name: 'Elena M.',
  role: 'Deportista aficionada'
}];
export function Testimonials() {
  return <SectionWrapper id="testimonios" className="px-4 md:px-12 max-w-6xl mx-auto" data-id="element-227">
      <div className="text-center mb-16" data-id="element-228">
        <h2 className="text-3xl md:text-5xl font-playfair text-forest mb-4" data-id="element-229">
          Lo que dicen nuestros lectores
        </h2>
        <p className="text-lg text-brown/80 max-w-2xl mx-auto" data-id="element-230">
          Personas reales que transformaron su rutina de cuidado de la piel.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-231">
        {testimonials.map((t, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.2
      }} className="bg-white p-8 rounded-3xl shadow-warm border border-sage/10 relative" data-id="element-232">
            <Quote className="absolute top-6 right-6 w-10 h-10 text-sage/20" data-id="element-233" />
            <div className="flex mb-4" data-id="element-234">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber fill-amber" data-id="element-235" />)}
            </div>
            <p className="text-brown/80 italic mb-6 leading-relaxed relative z-10" data-id="element-236">
              "{t.quote}"
            </p>
            <div className="border-t border-sage/20 pt-4" data-id="element-237">
              <p className="font-playfair font-bold text-forest text-lg" data-id="element-238">
                {t.name}
              </p>
              <p className="text-sm text-sage font-medium" data-id="element-239">{t.role}</p>
            </div>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}